/** Lightweight bridge so toast (App level) can open rule-save UI (Layout level). */

let pendingOffer = null;
let openModalHandler = null;

export const JOURNAL_ENTRY_SAVE_RULE_ACTION = 'JOURNAL_ENTRY_SAVE_RULE';

export const queueJournalEntryRuleSaveOffer = (offer) => {
  pendingOffer = offer || null;
};

export const peekJournalEntryRuleSaveOffer = () => pendingOffer;

export const clearJournalEntryRuleSaveOffer = () => {
  pendingOffer = null;
};

export const registerJournalEntryRuleSaveHost = (handler) => {
  openModalHandler = handler;
  return () => {
    if (openModalHandler === handler) {
      openModalHandler = null;
    }
  };
};

export const openJournalEntryRuleSaveModal = () => {
  if (pendingOffer && openModalHandler) {
    const offer = pendingOffer;
    pendingOffer = null;
    openModalHandler(offer);
  }
};
